import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 351,
    height: "100%",
  },
  media: {
    height: 200,
  },
  content: {
    height: "100%",
  },
  row: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  icons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  price: {
    textAlign: "center",
  },
  selected: {
    border: `3px solid ${theme.palette.primary.main}`,
  },
  link: {
    width: "100%",
    textDecoration: "none",
    color: theme.palette.text.primary,
  },
}));

export default function Place({
  node,
  selected,
  className,
  priceRefinement,
  onClick,
}) {
  const classes = useStyles();
  return (
    <Card
      className={classNames(
        classes.root,
        className,
        selected && classes.selected
      )}
    >
      <CardHeader
        avatar={
          <Avatar
            aria-label="recipe"
            src={node.photoUrl}
            className={classes.avatar}
          />
        }
        title={node.name}
        subheader={new Date(node.createdAt).toLocaleString()}
      />
      <CardActionArea>
        <CardContent className={classes.content}>
          {node.videoUrl ? (
            <div
              className="lo-emb-vid"
              style={{
                position: "relative",
                paddingBottom: "75%",
                height: 0,
              }}
            >
              <iframe
                src={node.videoUrl}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <Typography variant="body2" component="p">
              No video
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
